var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1488_89",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0351562,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1488_89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12.0352C12.55 12.0352 13.0208 11.8393 13.4125 11.4477C13.8042 11.056 14 10.5852 14 10.0352C14 9.48516 13.8042 9.01432 13.4125 8.62266C13.0208 8.23099 12.55 8.03516 12 8.03516C11.45 8.03516 10.9792 8.23099 10.5875 8.62266C10.1958 9.01432 10 9.48516 10 10.0352C10 10.5852 10.1958 11.056 10.5875 11.4477C10.9792 11.8393 11.45 12.0352 12 12.0352ZM12 22.0352C9.31667 19.7518 7.3125 17.631 5.9875 15.6727C4.6625 13.7143 4 11.9018 4 10.2352C4 7.73516 4.80417 5.74349 6.4125 4.26016C8.02083 2.77682 9.88333 2.03516 12 2.03516C14.1167 2.03516 15.9792 2.77682 17.5875 4.26016C19.1958 5.74349 20 7.73516 20 10.2352C20 11.9018 19.3375 13.7143 18.0125 15.6727C16.6875 17.631 14.6833 19.7518 12 22.0352Z",
    fill: "#FF471E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn);
export default __webpack_public_path__ + "static/media/location_on.5a68b068579892a6355e894afda30c46.svg";
export { ForwardRef as ReactComponent };